export default function CtaBanner() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-50">
      <div className="max-w-4xl mx-auto text-center mb-12">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-foreground-950 leading-tight mb-6">
          Comece a Comprar na<br />KASpreadsheet
        </h2>
        <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto mb-10 leading-relaxed">
          Aceda agora à plataforma completa com milhares de produtos das melhores categorias. Use o CSSBuy Spreadsheet para gerir todas as suas compras num só lugar.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base md:text-lg font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            CSSBuy Spreadsheet
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-base md:text-lg font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>

      <div className="w-full overflow-hidden">
        <div className="flex gap-3 md:gap-4">
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20knit%20sweater%20in%20terracotta%20orange%20folded%20on%20light%20wooden%20surface%20next%20to%20dried%20eucalyptus%20leaves%2C%20warm%20autumn%20aesthetic%2C%20soft%20window%20light%20from%20left%2C%20lifestyle%20fashion%20photography%2C%20hygge%20cozy%20mood%2C%20rich%20textured%20fabric%20detail&width=400&height=560&seq=cta-v2-strip-01&orientation=portrait"
              alt="Produto 1"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Polished%20black%20leather%20loafer%20shoes%20placed%20on%20white%20marble%20step%20with%20elegant%20reflection%2C%20luxury%20fashion%20editorial%2C%20dramatic%20lighting%20from%20above%20casting%20defined%20shadows%2C%20sophisticated%20minimalist%20composition%2C%20rich%20leather%20texture%20visible&width=400&height=560&seq=cta-v2-strip-02&orientation=portrait"
              alt="Produto 2"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Striped%20cotton%20beach%20towel%20and%20wide%20brim%20straw%20hat%20on%20soft%20white%20sand%20surface%2C%20bright%20summer%20sunlight%20overhead%2C%20vacation%20lifestyle%20photography%2C%20cheerful%20Mediterranean%20aesthetic%2C%20breezy%20relaxed%20mood%2C%20turquoise%20sea%20hint%20in%20background&width=400&height=560&seq=cta-v2-strip-03&orientation=portrait"
              alt="Produto 3"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20silver%20jewelry%20display%20with%20delicate%20chain%20necklace%20draped%20on%20raw%20silk%20fabric%2C%20soft%20diffused%20light%20from%20above%2C%20luxury%20accessories%20photography%2C%20elegant%20refined%20composition%2C%20subtle%20metallic%20reflections%2C%20jewelry%20editorial%20style&width=400&height=560&seq=cta-v2-strip-04&orientation=portrait"
              alt="Produto 4"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Vintage%20film%20camera%20and%20leather%20bound%20journal%20on%20reclaimed%20wooden%20desk%2C%20warm%20golden%20afternoon%20light%20streaming%20through%20window%2C%20creative%20workspace%20aesthetic%2C%20nostalgic%20analog%20photography%2C%20artistic%20composition%20with%20warm%20amber%20tones&width=400&height=560&seq=cta-v2-strip-05&orientation=portrait"
              alt="Produto 5"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Potted%20fiddle%20leaf%20fig%20plant%20in%20woven%20rattan%20basket%20against%20cream%20textured%20wall%20corner%2C%20bright%20natural%20daylight%20from%20side%2C%20modern%20interior%20botanical%20photography%2C%20fresh%20vibrant%20green%20aesthetic%2C%20clean%20Scandinavian%20style%2C%20lush%20healthy%20leaves&width=400&height=560&seq=cta-v2-strip-06&orientation=portrait"
              alt="Produto 6"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Artisan%20ceramic%20coffee%20mug%20with%20perfect%20latte%20art%20heart%20design%20on%20reclaimed%20wood%20table%2C%20soft%20morning%20sunlight%2C%20cozy%20cafe%20aesthetic%2C%20warm%20rich%20coffee%20tones%2C%20lifestyle%20food%20photography%2C%20steam%20rising%20gently&width=400&height=560&seq=cta-v2-strip-07&orientation=portrait"
              alt="Produto 7"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-shrink-0 w-40 md:w-56 h-52 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20cashmere%20scarf%20in%20dusty%20rose%20pink%20draped%20elegantly%20over%20edge%20of%20light%20oak%20shelf%2C%20gentle%20side%20lighting%20creating%20soft%20shadows%2C%20luxury%20fashion%20detail%2C%20elegant%20textile%20photography%2C%20romantic%20soft%20mood%2C%20delicate%20fabric%20texture&width=400&height=560&seq=cta-v2-strip-08&orientation=portrait"
              alt="Produto 8"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}